
// this file is overwritten by `npm run build:pre`
var version = '1.4.1';
export default version;
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/version.js
// module id = 218
// module chunks = 0 1